import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Collection } from "../../http/collection";
import { Store } from "@ngxs/store";
import { Filter, FilterBuilder } from "../../http/filter";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { AdvancedReport, AdvancedReportData } from "@core/data/types/advanced-report";
import { tap } from "rxjs/operators";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";

export class AdvancedReportDeleted {
    static readonly type = "[AdvancedReportService] Report Deleted";
    constructor(public report: AdvancedReport){}
}

export class AdvancedReportUpdated {
    static readonly type = "[AdvancedReportService] Report Updated";
    constructor(public report: AdvancedReport){}
}

@Injectable()
export class AdvancedReportService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _store: Store,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get(reportKey: string, detail?: DetailRequest, shareKey: string = null): Observable<AdvancedReport> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<AdvancedReport>(`${this._baseUri}/advanced-report/${reportKey}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    compile(reportKey: string, orgKey: string, shareKey: string = null): Observable<any> {
        return this._http.get<any>(`${this._baseUri}/advanced-report/${reportKey}/org/${orgKey}`, this._httpHelperService.withShareKey({}, shareKey));
    }

    query(filter: Filter, detail?: DetailRequest): Observable<Collection<AdvancedReport>> {
        let params = {
            ...FilterBuilder.queryParams(filter),
            ...DetailRequestBuilder.queryParams(detail),
        }

        return this._http.get<Collection<any>>(`${this._baseUri}/advanced-report`, { params });
    }

    // TODO see if we need to handle create response
    create(model: Partial<AdvancedReport>): Observable<AdvancedReport> {
        return this._http.post<AdvancedReport>(`${this._baseUri}/advanced-report`, model);
    }

    update(key: string, model: Partial<AdvancedReport>) {
        return this._http.put<AdvancedReport>(`${this._baseUri}/advanced-report/${key}`, model)
            .pipe(
                tap(
                    report => this._store.dispatch(new AdvancedReportUpdated(report))
                )
            );
    }

    delete(key: string) {
        return this._http.delete<AdvancedReport>(`${this._baseUri}/advanced-report/${key}`)
            .pipe(
                tap(
                    report => this._store.dispatch(new AdvancedReportDeleted(report))
                )
            );
    }

    share(key: string, model: Partial<AdvancedReport>, emails: string[]) {
        let shareRequest = {
            report: model,
            emails
        }

        return this._http.put<AdvancedReport>(`${this._baseUri}/advanced-report/${key}/share`, shareRequest)
    }

    getShared(shareKey: string){
        return this._http.get<AdvancedReport>(`${this._baseUri}/advanced-report-shared/${shareKey}`);
    }

}